import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import classes from "./AveragePriceRangePicker.module.css";
import Colors from "../assets/Colors";
import Fonts from "../assets/Fonts";
import { Button } from "../Button/Button";
import { Row, Col } from "react-bootstrap";
import { PriceInput } from "../PriceInput/PriceInput";
import RangePickerWithGraph from "../../components/RangePickerWithGraph/RangePickerWithGraph";
import { LinkButtonWithIcon } from "../LinkButtonWithIcon/LinkButtonWithIcon";
import { ChakraProvider } from "@chakra-ui/react";

export function AveragePriceRangePicker({
  minAndMaxPrice = [0, 10],
  setMinAndMaxPrice,
  handlePriceRange,
  containerClass,
  showButtons
}) {
  function minPriceSetter(data) {
    const newArray = minAndMaxPrice.slice();
    newArray[0] = parseInt(data);
    setMinAndMaxPrice(newArray);
  }
  function maxPriceSetter(data) {
    const newArray = minAndMaxPrice.slice();
    newArray[1] = parseInt(data);
    setMinAndMaxPrice(newArray);
  }
  return (
    <ChakraProvider>
      <div
        className={`${[classes.card, containerClass && containerClass].join(
          " "
        )}`}
      >
        <Row className={`${[classes.cardFirstRow].join(" ")}`}>
          <Col md={12}>
            <p style={{ ...Fonts.p2, color: Colors.neutralShadesOfNero }}>
              The average price is{" "}
              <span style={{ ...Fonts.h9, color: Colors.neutralShadesOfNero }}>
                $50
              </span>
            </p>
          </Col>
          <Col md={12}>
            <RangePickerWithGraph
              value={minAndMaxPrice}
              setValue={setMinAndMaxPrice}
              min={10}
              max={1000}
              isMulti={true}
            />
          </Col>
          <Col md={12}>
            <div className={classes.priceInputs}>
              <div className={classes.input}>
                <PriceInput
                  state={minAndMaxPrice[0]}
                  setter={minPriceSetter}
                  prefix={"$"}
                  type={"number"}
                  maxValueLength={4}
                  label={"min price"}
                />
              </div>
              <span
                style={{
                  ...Fonts.input2,
                  lineHeight: "16px",
                  color: Colors.neutralShadesOfNero,
                }}
              >
                -
              </span>
              <div className={classes.input}>
                <PriceInput
                  state={minAndMaxPrice[1]}
                  setter={maxPriceSetter}
                  prefix={"$"}
                  type={"number"}
                  maxValueLength={5}
                  label={"max price"}

                />
              </div>
            </div>
          </Col>
        </Row>
        {/* Buttons Row */}
        {showButtons && <Row>
          <Col md={12}>
            <div
              className={`${[classes.btnsBox].join(" ")}`}
              style={{
                borderTop: `1px solid ${Colors.neutralShadesOfWhisper}`,
              }}
            >
              <LinkButtonWithIcon
                text={"Clear"}
                primary={false}
                customStyle={{
                  ...Fonts.b2,
                  lineHeight: "20px",
                  color: Colors.neutralShadesOfNero,
                }}
                onClick={() => setMinAndMaxPrice([0, 100])}
              />
              <Button
                onClick={handlePriceRange}
                label={"Save"}
                primary={true}
                size={"Small"}
                customStyle={{ width: "64px", height: "36px" }}
              />
            </div>
          </Col>
        </Row>}
      </div>
    </ChakraProvider>
  );
}

AveragePriceRangePicker.propTypes = {
  minAndMaxPrice: PropTypes.array,
  setMinAndMaxPrice: PropTypes.func,
};
AveragePriceRangePicker.defaultProps = {
  minAndMaxPrice: [0, 10],
};
